import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { Form } from "./Form";
import { Table } from "./Table";
import useToggle from "../../hooks/useToggle";
import { IRole } from "../../models/BaseModel";

export interface IModel {
    open: boolean,
    singleData: IRole
}

export const Role = ({ hasPermission }: { hasPermission: (pageName: string, featureName?: string) => boolean }) => {
console.log(hasPermission,"haspermisson")
    const [modal, setModal] = useState({ singleData: {}, open: false } as IModel);
    const [reload, reloadData] = useToggle();
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false })
    };

    return (
        <>
            { <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reloadData={reloadData}></Form>}
            <Table  setModal={setModal} toast={toast} reload={reload} hasPermission={hasPermission}></Table>
            <Toast ref={toast} />
        </>
    );
}
